/**
 * This file was auto-generated by Fern from our API Definition.
 */

import * as errors from "../../../../errors/index.js";
import * as core from "../../../../core/index.js";

export class Error extends errors.LangfuseAPIError {
  constructor(body?: unknown, rawResponse?: core.RawResponse) {
    super({
      message: "Error",
      statusCode: 400,
      body: body,
      rawResponse: rawResponse,
    });
    Object.setPrototypeOf(this, Error.prototype);
  }
}
